import React from 'react';
import {
  ContainerTrackOrder,
  ListItem,
  ListItemContent,
  ListItemHeader,
  ListItemSubHeader,
} from '../../style/ShippingNotesWmo.css';
import {
  FastShipping,
  GuaranteedFit,
  HassleFreeReturns,
} from '@usap/uicomponents';

function ShippingNotesTrackOrder() {
  return (
    <ContainerTrackOrder>
      {/* item1 */}
      <ListItem>
        <GuaranteedFit />
        <ListItemContent>
          <ListItemHeader>Guaranteed to Fit</ListItemHeader>
          <ListItemSubHeader>Convenient vehicle selection</ListItemSubHeader>
        </ListItemContent>
      </ListItem>
      {/* item2 */}
      <ListItem>
        <FastShipping />
        <ListItemContent>
          <ListItemHeader>Fast Shipping</ListItemHeader>
          <ListItemSubHeader>Get the part when you need it</ListItemSubHeader>
        </ListItemContent>
      </ListItem>
      {/* item3 */}
      <ListItem>
        <HassleFreeReturns />
        <ListItemContent>
          <ListItemHeader>Hassle-Free Returns</ListItemHeader>
          <ListItemSubHeader>
            Simple & convenient online returns
          </ListItemSubHeader>
        </ListItemContent>
      </ListItem>
    </ContainerTrackOrder>
  );
}

export default ShippingNotesTrackOrder;
